import { Component } from '@angular/core';

@Component({
  selector: 'edge-global-bottom',
  templateUrl: './bottom.component.html',
  styleUrls: ['./bottom.component.scss']
})
export class GlobalBottomComponent {
  goArmyUrl(): string {
    let goArmyUrl = 'https://www.goarmy.com/?iom=AFOD-2675107_GER_Football';

    if (window.location.href.includes('soccer')) {
      return (goArmyUrl =
        'https://www.goarmy.com/?iom=AFOD-2675107_GER_Soccer');
    }

    return goArmyUrl;
  }
}
